// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"255":"test","389":"404","962":"home"}[chunkId] || chunkId) + "." + {"255":"9ac90a16","389":"c6fa9534","855":"35b3ff68","962":"7c072182"}[chunkId] + ".js";
};